import React from "react";
import classNames from "classnames";
import {UICondition, UIHelpers, UIMarginBottom} from "../../utils";
export enum HeadingStyle { notset, heading, title, callout, subheading }
export enum HeadingElement { notset, h1, h2, h3, div, span }

import "./Heading.scss";

const defaultProps = {
  headingStyle: HeadingStyle.title,
  headingElement: HeadingElement.div,
  condition: UICondition.none,
  marginBottom: UIMarginBottom.none
}

export interface IHeading extends React.HTMLProps<Heading> {
  headingStyle?: HeadingStyle;
  headingElement?: HeadingElement;
  condition?: UICondition;
  marginBottom?: UIMarginBottom;
}

type DefaultProps = Readonly<typeof defaultProps>

/**
 * Heading with a sub heaading
 *
 * @status deprecated
 *
 * @deprecated use plain HTML tags instead
 */
export class Heading extends React.Component<IHeading & DefaultProps>{
  static HeadingStyle = HeadingStyle;
  static HeadingElement = HeadingElement;
  static UICondition = UICondition;
  static MarginBottom = UIMarginBottom;

  static defaultProps = defaultProps;

  render(){
    let headingStyleClass;
    const marginBottomClass = UIHelpers.GetMarginBottomClass(this.props.marginBottom);

    switch (this.props.headingStyle) {
      case HeadingStyle.heading:
      headingStyleClass = classNames("heading", this.props.className, UIHelpers.GetConditionClass(this.props.condition), marginBottomClass);
        break;
      case HeadingStyle.title:
      headingStyleClass = classNames("title", this.props.className, UIHelpers.GetConditionClass(this.props.condition), marginBottomClass);
        break;
      case HeadingStyle.callout:
      headingStyleClass = classNames("callout", this.props.className, UIHelpers.GetConditionClass(this.props.condition), marginBottomClass);
        break;
      case HeadingStyle.subheading:
      headingStyleClass = classNames("subheading", this.props.className, UIHelpers.GetConditionClass(this.props.condition), marginBottomClass);
        break;
    }

    switch (this.props.headingElement) {
      case HeadingElement.h1:
      return (
        <h1 className={headingStyleClass}>{this.props.children}</h1>
      );
      case HeadingElement.h2:
      return (
        <h2 className={headingStyleClass}>{this.props.children}</h2>
      );
      case HeadingElement.h3:
      return (
        <h3 className={headingStyleClass}>{this.props.children}</h3>
      );
      case HeadingElement.div:
      return (
        <div className={headingStyleClass}>{this.props.children}</div>
      );
      default:
      return (
        <span className={headingStyleClass}>{this.props.children}</span>
      );

    }
  }
}
